setTimeout(function(){
  $('.state').html("Région");
}, 500);